export const BADGE_SIZES_JSS = {
  "&.s": {
    width: 30,
    height: 30,
  },
  "&.m": {
    width: 40,
    height: 40,
  },
  "&.l": {
    width: 60,
    height: 60,
  },

  "&.xxl-48": {
    width: 48,
    height: 48,
    fontSize: 28,
    lineHeight: "48px",
  },
  "&.xxxl": {
    width: 52,
    height: 52,
    fontSize: 32,
    lineHeight: "52px",
  },
  "&.xxxxxl": { width: 120, height: 120 },
};
